import React, { useEffect } from "react";
import WebBanner from "../HomePage/Technology/AllBanner/WebBanner";
import WebMain from "./TechnologiesWebPage/WebMain";
import FooterContact from "../FooterContactPage/FooterContact";
import { Helmet } from "react-helmet-async";

const TechWeb = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <Helmet>
        <title>Web Technologies and Frameworks | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Explore the web technologies and frameworks used by Quad Theory Ltd, including .NET, React, TypeScript, Blazor, HTML, CSS, and Python. Built for scalable, reliable, and long-term web platforms."
        />
      </Helmet>
      <WebBanner />
      <WebMain />
      {/* form component yeameen */}
      <FooterContact />
    </div>
  );
};

export default TechWeb;
